<script setup lang="ts">
import { ref } from 'vue'
import { getToken } from '@/utils/token'
import { IMAGE_CDN } from '@/config/app.config'

const previewSrc = ref('')

const openCustomerService = () => {
    const width = 400
    const height = 700
    const left = window.screenX + (window.outerWidth - width) / 2
    const top = window.screenY + (window.outerHeight - height) / 2
    window.open(
        `https://m.gibbous.net/pages/customerService/customerService?token=${getToken()}`,
        '_blank',
        `width=${width},height=${height},left=${left},top=${top}`
    )
}
</script>

<template>
    <div class="float-sidebar">
        <!-- APP 二维码 -->
        <!-- <div class="qr-card" @click="previewSrc = IMAGE_CDN + '/xcx/appewm.png'">
            <img :src="IMAGE_CDN + '/xcx/appewm.png'" alt="APP二维码" />
            <span>扫码下载APP</span>
        </div> -->

        <!-- 小程序二维码 -->
        <!-- <div class="qr-card" @click="previewSrc = IMAGE_CDN + '/xcx/xcxewm.png'">
            <img :src="IMAGE_CDN + '/xcx/xcxewm.png'" alt="小程序二维码" />
            <span>扫码进入小程序</span>
        </div> -->

        <!-- 二维码放大预览 -->
        <teleport to="body">
            <div v-if="previewSrc" class="qr-overlay" @click="previewSrc = ''">
                <img :src="previewSrc" alt="二维码预览" />
            </div>
        </teleport>

        <!-- 客服浮窗 -->
        <div class="golf-service-widget" @click="openCustomerService">
            <div class="avatar-wrapper">
                <img :src="IMAGE_CDN + '/xcx/home/meiru.png'" alt="专属客服" />
                <div class="online-status"></div>
            </div>
            <div class="service-label">专属客服</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.float-sidebar {
    position: fixed;
    right: 30px;
    bottom: 80px;
    z-index: 999;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

/* 二维码卡片 */
.qr-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    background: #fff;
    border-radius: 10px;
    padding: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.12);
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.05);
    }

    img {
        width: 100px;
        min-width: 100px;
        height: 100px;
        border-radius: 6px;
        max-width: none;
    }

    span {
        font-size: 11px;
        color: #333;
        font-weight: 500;
        white-space: nowrap;
    }
}

/* 客服悬浮窗 */
.golf-service-widget {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    font-family: "Microsoft YaHei", sans-serif;

    .avatar-wrapper {
        position: relative;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        border: 3px solid #ffd700;
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
        background: #fff;
        transition: all 0.3s ease;
        animation: breath 2s infinite ease-in-out;

        img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
        }
    }

    .online-status {
        position: absolute;
        bottom: 5px;
        right: 5px;
        width: 15px;
        height: 15px;
        background-color: #2ecc71;
        border: 2px solid #fff;
        border-radius: 50%;
    }

    .service-label {
        margin-top: 8px;
        background: #ffd700;
        color: #004d40;
        padding: 2px 10px;
        border-radius: 20px;
        font-size: 16px;
        font-weight: bold;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        white-space: nowrap;
    }

    &:hover .avatar-wrapper {
        transform: scale(1.1);
        box-shadow: 0 0 20px rgba(255, 215, 0, 0.6);
        animation-play-state: paused;
    }

    @keyframes breath {
        0% {
            transform: scale(1);
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
        }
        50% {
            transform: scale(1.05);
            box-shadow: 0 4px 25px rgba(255, 215, 0, 0.4);
        }
        100% {
            transform: scale(1);
            box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
        }
    }
}
</style>

<style lang="scss">
.qr-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
        max-width: 360px;
        max-height: 360px;
        border-radius: 12px;
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
    }
}
</style>
